(function () {
  'use strict';
  var rules = [
    { terms: ['5er covid','covid 5er','corona 5er','5er box'], label: 'COVID-19 · 5er Boxen', url: '/collections/covid-19-schnelltests-5er-boxen', meta: 'Direkt zu den Mehrfachpackungen' },
    { terms: ['kombitest','kombi test','3in1','3 in 1','4in1','4 in 1','5in1','5 in 1','6in1','6 in 1','influenza','grippe','rsv'], label: 'Kombi-Schnelltests', url: '/collections/3in1-4in1-kombi-tests', meta: 'COVID-19, Influenza, RSV & weitere Kombinationen' },
    { terms: ['covid','corona','sars-cov','sars cov','antigentest','antigen test'], label: 'COVID-19 Schnelltests', url: '/collections/covid-19-schnelltests-1', meta: 'Direkt zum bekannten Corona-Testsortiment' }
  ];

  function norm(value) {
    return (value || '').toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function matchRule(query) {
    query = norm(query);
    if (!query) return null;
    for (var i = 0; i < rules.length; i++) {
      for (var j = 0; j < rules[i].terms.length; j++) {
        if (query.indexOf(rules[i].terms[j]) !== -1) return rules[i];
      }
    }
    return null;
  }

  function decorate(form) {
    if (!form) return;
    var input = form.querySelector('input[name="q"], input[type="search"], .search-bar__input');
    var panel = form.querySelector('.jon-search-panel');
    if (!input || !panel) return;
    var rule = matchRule(input.value);
    var old = panel.querySelector('[data-jon-covid-direct]');
    if (!rule) {
      if (old) old.remove();
      return;
    }
    if (old && old.getAttribute('href') === rule.url) return;
    if (old) old.remove();
    var link = document.createElement('a');
    link.className = 'jon-search__topic jon-search__topic--covid';
    link.href = rule.url;
    link.setAttribute('data-jon-covid-direct', '');
    link.innerHTML = '<span><small>' + rule.meta + '</small><strong>' + rule.label + '</strong></span><b aria-hidden="true">→</b>';
    panel.insertBefore(link, panel.firstChild);
  }

  function decorateAll() {
    document.querySelectorAll('form.search-bar').forEach(decorate);
  }

  document.addEventListener('input', function (event) {
    if (!event.target.closest || !event.target.closest('form.search-bar')) return;
    window.setTimeout(decorateAll, 40);
  });
  document.addEventListener('focusin', function (event) {
    if (!event.target.closest || !event.target.closest('form.search-bar')) return;
    window.setTimeout(decorateAll, 40);
  });

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].target && mutations[i].target.closest && mutations[i].target.closest('form.search-bar')) {
        decorateAll();
        break;
      }
    }
  });
  if (document.documentElement) observer.observe(document.documentElement, { childList: true, subtree: true });
})();